import { useProductStore } from "src/stores/product";

export function useRequestAgain({ closeForm, formData, permissions }) {
  const isRequestAgainLoading = ref(false);
  const { putProduct } = useProductStore();

  const confirmRequestAgainToggleStatus = async () => {
    try {
      isRequestAgainLoading.value = true;

      await putProduct(unref(formData));

      isRequestAgainLoading.value = false;

      closeForm(true);
    } catch {
      isRequestAgainLoading.value = false;

      closeForm(true);
    }
  };
  const requestAgainButton = computed(() => {
    return {
      label: "Request Again",
      type: "button",
      loading: unref(isRequestAgainLoading),
      disable: !unref(permissions).products.request,
      onClick: confirmRequestAgainToggleStatus,
    };
  });

  return {
    requestAgainButton,
  };
}
